import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/end_ligth.png'
import _imports_1 from '../assets/image/end_hand.png'
import _imports_2 from '../assets/image/end_panda.png'
import _imports_3 from '../assets/image/end_star.png'
import _imports_4 from '../assets/image/end_tip.png'
import _imports_5 from '../assets/image/end_btn.png'
import _imports_6 from '../assets/image/end_bg.jpg'
import _imports_7 from '../assets/image/poster.jpg'
import _imports_8 from '../assets/image/restart.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e7393978")

_pushScopeId("data-v-e7393978")
const _hoisted_1 = { class: "end" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "end-light",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "end-hand",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "end-panda",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "end-star",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "end-tip",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "camera"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_7,
  alt: "海报"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("img", {
      class: "end-btn",
      src: _imports_5,
      alt: "",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowPoster = true))
    }),
    (_ctx.isShowPoster)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9
        ], 512)), [
          [_vShow, _ctx.isShowPoster]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("img", {
      class: "end-restart",
      src: _imports_8,
      alt: "",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRestart && _ctx.handleRestart(...args)))
    }, null, 512), [
      [_vShow, _ctx.isShowPoster]
    ])
  ]))
})